export default {
  en: {
    'components.registration-list-item.registration-type': '{regType} registration',
    'components.registration-list-item.registration-number': 'Registration no: {regNo}',
    'components.registration-list-item.registration-date': 'Registration date: {regDate}',
    'components.registration-list-item.local-vat-no': 'Local VAT no: {localVatNo}',
    'components.registration-list-item.non-managed': 'non-managed',
  },
};
